/**
 * Mapeia `res.data` da ação `buscarUsuarioComConfigs` → token Bearer + id para API/Echo de notificações.
 *
 * Contrato Magos: `data.token`, `data.empreender_plus_user_id`.
 */
export function extractHubSessionForNotifications(hubData: unknown): {
	plus_token: string | null;
	empreender_plus_user_id: string | number | null;
} {
	if (hubData === null || typeof hubData !== 'object' || Array.isArray(hubData)) {
		return { plus_token: null, empreender_plus_user_id: null };
	}

	const data = hubData as Record<string, unknown>;
	const rawToken = data.token;
	const plus_token = typeof rawToken === 'string' && rawToken.trim() !== '' ? rawToken.trim() : null;

	const rawId = data.empreender_plus_user_id;
	const empreender_plus_user_id =
		typeof rawId === 'string' || typeof rawId === 'number' ? rawId : null;

	return { plus_token, empreender_plus_user_id };
}
